module.exports = __webpack_public_path__ + "static/media/avocado.e2cab440.jpg";